'use strict';

var ctrl = function (
  $scope,
  $rootScope,
  $sessionStorage,
  $compile,
  $state,
  ngDroCoreNavBar,
  $location
) {
  var profile = $sessionStorage.profile;
  console.log($location.url());
  console.log($state.current.name);
  if (!profile) {
    sessionStorage.setItem('redirectUrl', $state.current.name);
    $state.go('login');
  }

  if (profile) {
    $scope.user = {
      email: profile.email,
      firstName: profile.firstName,
      lastName: profile.lastName,
    };
  }

  $scope.addDirective = function () {
    var languagesScope = {};
    languagesScope.languages = [
      {
        title: 'ngDro-core.italian',
        code: 'it',
        short: 'IT',
      },
      {
        title: 'ngDro-core.english',
        code: 'en',
        short: 'EN',
      },
    ];

    ngDroCoreNavBar.register({
      html: '<div ng-dro-core-language-switch languages="languages"></div>',
      data: languagesScope,
      position: 1,
    });
    console.log('ok');
  };
  $scope.removeDirective = function () {};

  $scope.logout = function () {
    $state.go('logout');
  };
};

module.exports = [
  '$scope',
  '$rootScope',
  '$sessionStorage',
  '$compile',
  '$state',
  'ngDroCoreNavBar',
  '$location',
  ctrl,
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/components/main/mainCtrl.js
// module id = 311
// module chunks = 0